export default {
    en: {
        intro: "To get started with this WhatsApp task, we'll need to send you an invite.",
        checkNumber: "Before we do, please check that this is your correct mobile number:",
        mobileNumber: "Your mobile number: +{msisdn}",
        incorrectDetails: "If these details are incorrect please contact",
        sendInvite: "Otherwise, click the button below to send an invite to your phone (via WhatsApp) and get started.",
        noInvite: "If you don’t receive anything within 5 minutes and the mobile number is correct, please contact us on",
        updateDetails: "and we will get your details updated as soon as possible.",
        supportTicketAlt: "Alternatively you can raise a support ticket",
        supportLink: "here",
        whatsappInstructions: "Once you receive the invite on WhatsApp, please read the instructions carefully on how to take part.",
        noMobile: "It looks like we don't have a mobile number for you, please contact",
        noMobile2: "to get you up and running",
        intro2: "You are about to take part in a WhatsApp task",
    },
    in: {
        intro: "Untuk memulai tugas WhatsApp ini, kami perlu mengirimkan undangan kepada Anda.",
        checkNumber: "Sebelum itu, harap periksa bahwa ini adalah nomor ponsel Anda yang benar:",
        mobileNumber: "Nomor ponsel Anda: +{msisdn}",
        incorrectDetails: "Jika detail ini salah silakan hubungi",
        sendInvite: "Jika tidak, klik tombol di bawah untuk mengirim undangan ke ponsel Anda (melalui WhatsApp) dan mulai.",
        noInvite: "Jika Anda tidak menerima apa pun dalam waktu 5 menit dan nomor ponsel sudah benar, silakan hubungi kami di",
        updateDetails: "dan kami akan memperbarui detail Anda sesegera mungkin.",
        supportTicketAlt: "Sebagai alternatif, Anda bisa membuat tiket dukungan",
        supportLink: "di sini",
        whatsappInstructions: "Setelah Anda menerima undangan di WhatsApp, harap baca instruksi dengan cermat tentang cara berpartisipasi.",
        noMobile: "Sepertinya kami tidak memiliki nomor ponsel Anda, silakan hubungi",
        noMobile2: "agar Anda bisa segera memulai",
        intro2: "Anda akan segera ikut serta dalam tugas WhatsApp",
    },
    zh: {
        intro: "要开始此 WhatsApp 任务，我们需要向您发送邀请。",
        checkNumber: "在此之前，请确认这是您的正确手机号码：",
        mobileNumber: "您的手机号码：+{msisdn}",
        incorrectDetails: "如果这些信息有误，请联系我们",
        sendInvite: "否则，请点击下面按钮，通过 WhatsApp 向您的手机发送邀请并开始。",
        noInvite: "如果在 5 分钟内未收到任何内容，且手机号码正确，请通过以下方式联系我们",
        updateDetails: "我们会尽快为您更新信息。",
        supportTicketAlt: "或者，您可以提出支持请求",
        supportLink: "点击这里",
        whatsappInstructions: "一旦您收到 WhatsApp 邀请，请仔细阅读说明了解参与方式。",
        noMobile: "看起来我们没有您的手机号码，请联系",
        noMobile2: "以便为您开通服务",
        intro2: "您即将参加一个 WhatsApp 任务",
    },
    nl: {
        intro: "Om te beginnen met deze WhatsApp-taak, moeten we je een uitnodiging sturen.",
        checkNumber: "Controleer eerst of dit je correcte mobiele nummer is:",
        mobileNumber: "Je mobiele nummer: +{msisdn}",
        incorrectDetails: "Als deze gegevens onjuist zijn, neem dan contact op met",
        sendInvite: "Klik anders op onderstaande knop om een uitnodiging via WhatsApp naar je telefoon te sturen en te beginnen.",
        noInvite: "Als je binnen 5 minuten niets ontvangt en het mobiele nummer klopt, neem dan contact met ons op via",
        updateDetails: "en we zullen je gegevens zo snel mogelijk bijwerken.",
        supportTicketAlt: "Je kunt ook een supportticket aanmaken",
        supportLink: "hier",
        whatsappInstructions: "Zodra je de uitnodiging op WhatsApp ontvangt, lees dan zorgvuldig de instructies hoe je kunt meedoen.",
        noMobile: "Het lijkt erop dat we geen mobiel nummer van je hebben, neem contact op met",
        noMobile2: "om je snel op weg te helpen",
        intro2: "Je staat op het punt deel te nemen aan een WhatsApp-taak",
    },
    fi: {
        intro: "Aloittaaksemme tämän WhatsApp-tehtävän, meidän on lähetettävä sinulle kutsu.",
        checkNumber: "Ennen sitä, tarkistathan että tämä on oikea matkapuhelinnumerosi:",
        mobileNumber: "Matkapuhelinnumerosi: +{msisdn}",
        incorrectDetails: "Jos tiedot ovat virheelliset, ota yhteyttä",
        sendInvite: "Muussa tapauksessa napsauta alla olevaa painiketta lähettääksesi kutsun puhelimeesi (WhatsAppin kautta) ja aloittaaksesi.",
        noInvite: "Jos et saa mitään viiden minuutin kuluessa ja matkapuhelinnumero on oikein, ota meihin yhteyttä",
        updateDetails: "ja päivitämme tietosi mahdollisimman pian.",
        supportTicketAlt: "Vaihtoehtoisesti voit luoda tukipyynnön",
        supportLink: "täältä",
        whatsappInstructions: "Kun saat kutsun WhatsAppissa, lue ohjeet huolellisesti osallistuaksesi.",
        noMobile: "Näyttää siltä, että meillä ei ole puhelinnumeroasi, ota yhteyttä",
        noMobile2: "jotta pääset alkuun",
        intro2: "Olet aloittamassa WhatsApp-tehtävän",
    },
    fr: {
        intro: "Pour commencer cette tâche WhatsApp, nous devons vous envoyer une invitation.",
        checkNumber: "Avant cela, veuillez vérifier que c’est bien votre numéro de mobile :",
        mobileNumber: "Votre numéro de mobile : +{msisdn}",
        incorrectDetails: "Si ces informations sont incorrectes, veuillez contacter",
        sendInvite: "Sinon, cliquez sur le bouton ci-dessous pour envoyer une invitation à votre téléphone (via WhatsApp) et commencer.",
        noInvite: "Si vous ne recevez rien dans les 5 minutes et que le numéro est correct, contactez-nous au",
        updateDetails: "et nous mettrons vos informations à jour dès que possible.",
        supportTicketAlt: "Vous pouvez également créer un ticket de support",
        supportLink: "ici",
        whatsappInstructions: "Une fois l’invitation reçue sur WhatsApp, veuillez lire attentivement les instructions pour savoir comment participer.",
        noMobile: "Il semble que nous n’ayons pas votre numéro de mobile, veuillez contacter",
        noMobile2: "pour que nous puissions vous activer rapidement",
        intro2: "Vous êtes sur le point de participer à une tâche WhatsApp",
    },
    de: {
        intro: "Um diese WhatsApp-Aufgabe zu starten, müssen wir Ihnen eine Einladung senden.",
        checkNumber: "Bitte prüfen Sie vorher, ob dies Ihre richtige Mobilnummer ist:",
        mobileNumber: "Ihre Mobilnummer: +{msisdn}",
        incorrectDetails: "Wenn diese Angaben falsch sind, kontaktieren Sie bitte",
        sendInvite: "Andernfalls klicken Sie auf den Button unten, um eine Einladung per WhatsApp auf Ihr Telefon zu senden und zu beginnen.",
        noInvite: "Wenn Sie innerhalb von 5 Minuten nichts erhalten und die Nummer korrekt ist, kontaktieren Sie uns unter",
        updateDetails: "und wir werden Ihre Daten so schnell wie möglich aktualisieren.",
        supportTicketAlt: "Alternativ können Sie ein Support-Ticket erstellen",
        supportLink: "hier",
        whatsappInstructions: "Sobald Sie die Einladung per WhatsApp erhalten, lesen Sie bitte die Anweisungen sorgfältig durch, um an der Teilnahme zu erfahren.",
        noMobile: "Es sieht so aus, als hätten wir keine Handynummer von Ihnen, bitte kontaktieren Sie",
        noMobile2: "damit wir Sie schnell einrichten können",
        intro2: "Sie sind dabei, an einer WhatsApp-Aufgabe teilzunehmen",
    },
    hi: {
        intro: "इस WhatsApp कार्य को शुरू करने के लिए, हमें आपको एक निमंत्रण भेजना होगा।",
        checkNumber: "इसके पहले कृपया जाँचें कि यह आपका सही मोबाइल नंबर है:",
        mobileNumber: "आपका मोबाइल नंबर: +{msisdn}",
        incorrectDetails: "यदि ये विवरण गलत हैं तो कृपया संपर्क करें",
        sendInvite: "अन्यथा, नीचे दिए गए बटन पर क्लिक करें ताकि हम आपके फोन (WhatsApp के माध्यम से) निमंत्रण भेज सकें और प्रक्रिया शुरू हो सके।",
        noInvite: "यदि आपको 5 मिनट के अंदर कुछ नहीं मिलता और मोबाइल नंबर सही है, तो कृपया हमसे संपर्क करें",
        updateDetails: "और हम जल्द से जल्द आपके विवरण अपडेट कर देंगे।",
        supportTicketAlt: "यदि चाहें तो आप एक सपोर्ट टिकट भी बना सकते हैं",
        supportLink: "यहाँ",
        whatsappInstructions: "एक बार जब आपको WhatsApp पर निमंत्रण मिल जाए, तो कृपया भाग लेने के निर्देशों को ध्यान से पढ़ें।",
        noMobile: "लगता है कि हमारे पास आपका मोबाइल नंबर नहीं है, कृपया संपर्क करें",
        noMobile2: "ताकि हम आपको शुरू करने में मदद कर सकें",
        intro2: "आप WhatsApp कार्य में भाग लेने वाले हैं",
    },
    it: {
        intro: "Per iniziare questa attività su WhatsApp, dobbiamo inviarti un invito.",
        checkNumber: "Prima di farlo, controlla che questo sia il tuo numero di cellulare corretto:",
        mobileNumber: "Il tuo numero di cellulare: +{msisdn}",
        incorrectDetails: "Se questi dettagli sono errati, per favore contatta",
        sendInvite: "Altrimenti, clicca il pulsante qui sotto per inviare un invito al tuo telefono (via WhatsApp) e iniziare.",
        noInvite: "Se non ricevi nulla entro 5 minuti e il numero è corretto, contattaci al",
        updateDetails: "e aggiorneremo i tuoi dati il prima possibile.",
        supportTicketAlt: "In alternativa puoi aprire un ticket di supporto",
        supportLink: "qui",
        whatsappInstructions: "Una volta ricevuto l’invito su WhatsApp, leggi attentamente le istruzioni su come partecipare.",
        noMobile: "Sembra che non abbiamo il tuo numero di cellulare, contatta",
        noMobile2: "per poterti attivare subito",
        intro2: "Stai per partecipare a un’attività WhatsApp",
    },
    ja: {
        intro: "この WhatsApp タスクを開始するには、招待を送信する必要があります。",
        checkNumber: "その前に、こちらが正しい携帯番号かご確認ください：",
        mobileNumber: "あなたの携帯番号：+{msisdn}",
        incorrectDetails: "情報が正しくない場合は、お問い合わせください",
        sendInvite: "それ以外の場合は、以下のボタンをクリックして、WhatsApp 経由で招待をあなたの電話に送信し、開始してください。",
        noInvite: "5 分以内に何も届かず、携帯番号が正しい場合は、お問い合わせください",
        updateDetails: "できるだけ早く詳細を更新いたします。",
        supportTicketAlt: "または、サポートチケットを作成することもできます",
        supportLink: "こちら",
        whatsappInstructions: "WhatsApp で招待を受け取ったら、参加方法の指示をよくお読みください。",
        noMobile: "携帯番号が登録されていないようです。お問い合わせください",
        noMobile2: "すぐにご利用いただけるようにするために",
        intro2: "WhatsApp タスクに参加しようとしています",
    },
    ko: {
        intro: "이 WhatsApp 작업을 시작하려면 초대장을 보내야 합니다.",
        checkNumber: "그 전에, 이것이 정확한 휴대폰 번호인지 확인해 주세요:",
        mobileNumber: "사용자의 휴대폰 번호: +{msisdn}",
        incorrectDetails: "이 정보가 올바르지 않은 경우 문의해 주세요",
        sendInvite: "그렇지 않으면 아래 버튼을 눌러 WhatsApp을 통해 휴대폰으로 초대장을 보내고 시작하세요.",
        noInvite: "5분 내에 아무것도 받지 못했고 번호가 정확하다면, 저희에게 연락주세요",
        updateDetails: "최대한 빨리 정보를 업데이트해드리겠습니다.",
        supportTicketAlt: "또는 지원 티켓을 제출할 수도 있습니다",
        supportLink: "여기",
        whatsappInstructions: "WhatsApp 초대장을 받으면, 참여 방법에 대한 안내를 주의 깊게 읽어주세요.",
        noMobile: "등록된 휴대폰 번호가 없는 것 같습니다. 문의해 주세요",
        noMobile2: "바로 시작할 수 있도록",
        intro2: "곧 WhatsApp 작업에 참여하게 됩니다",
    },
    pl: {
        intro: "Aby rozpocząć to zadanie WhatsApp, musimy wysłać Ci zaproszenie.",
        checkNumber: "Zanim to zrobimy, sprawdź proszę, czy jest to Twój poprawny numer telefonu:",
        mobileNumber: "Twój numer telefonu: +{msisdn}",
        incorrectDetails: "Jeśli dane są nieprawidłowe, skontaktuj się z nami",
        sendInvite: "W przeciwnym razie kliknij przycisk poniżej, aby wysłać zaproszenie na telefon (przez WhatsApp) i rozpocząć.",
        noInvite: "Jeśli nie otrzymasz nic w ciągu 5 minut i numer jest poprawny, skontaktuj się z nami pod",
        updateDetails: "a my zaktualizujemy Twoje dane jak najszybciej.",
        supportTicketAlt: "Alternatywnie możesz zgłosić ticket do wsparcia",
        supportLink: "tutaj",
        whatsappInstructions: "Po otrzymaniu zaproszenia przez WhatsApp, przeczytaj dokładnie instrukcje, jak wziąć udział.",
        noMobile: "Wygląda na to, że nie mamy Twojego numeru telefonu, skontaktuj się z",
        noMobile2: "aby szybko Cię uruchomić",
        intro2: "Zaraz weźmiesz udział w zadaniu WhatsApp",
    },
    pt: {
        intro: "Para começar esta tarefa no WhatsApp, precisamos enviar um convite para você.",
        checkNumber: "Antes disso, por favor, verifique se este é o seu número de celular correto:",
        mobileNumber: "Seu número de celular: +{msisdn}",
        incorrectDetails: "Se esses dados estiverem incorretos, entre em contato",
        sendInvite: "Caso contrário, clique no botão abaixo para enviar um convite para seu telefone (via WhatsApp) e começar.",
        noInvite: "Se você não receber nada em até 5 minutos e o número estiver correto, entre em contato conosco pelo",
        updateDetails: "e atualizaremos seus dados o mais rápido possível.",
        supportTicketAlt: "Você também pode abrir um ticket de suporte",
        supportLink: "aqui",
        whatsappInstructions: "Assim que você receber o convite no WhatsApp, leia atentamente as instruções sobre como participar.",
        noMobile: "Parece que não temos o seu número de celular, entre em contato com",
        noMobile2: "para colocá-lo em funcionamento",
        intro2: "Você está prestes a participar de uma tarefa no WhatsApp",
    },
    es: {
        intro: "Para comenzar con esta tarea de WhatsApp, necesitamos enviarte una invitación.",
        checkNumber: "Antes de ello, por favor verifica que este sea tu número de móvil correcto:",
        mobileNumber: "Tu número de móvil: +{msisdn}",
        incorrectDetails: "Si estos datos son incorrectos, por favor contacta con nosotros",
        sendInvite: "De lo contrario, haz clic en el botón de abajo para enviarte una invitación a tu teléfono (vía WhatsApp) y comenzar.",
        noInvite: "Si no recibes nada en 5 minutos y el número es correcto, por favor contáctanos en",
        updateDetails: "y actualizaremos tus datos lo antes posible.",
        supportTicketAlt: "Como alternativa, puedes crear un ticket de soporte",
        supportLink: "aquí",
        whatsappInstructions: "Una vez que recibas la invitación en WhatsApp, lee cuidadosamente las instrucciones sobre cómo participar.",
        noMobile: "Parece que no tenemos tu número de móvil, por favor contacta con",
        noMobile2: "para ponerte en marcha",
        intro2: "Estás a punto de participar en una tarea de WhatsApp",
    },
    tr: {
        intro: "Bu WhatsApp görevine başlamak için, size bir davetiye göndermemiz gerekecek.",
        checkNumber: "Bunu yapmadan önce, lütfen bu numaranın doğru mobil numaranız olduğundan emin olun:",
        mobileNumber: "Mobil numaranız: +{msisdn}",
        incorrectDetails: "Eğer bu bilgiler yanlışsa lütfen iletişime geçin",
        sendInvite: "Aksi halde, telefonunuza (WhatsApp üzerinden) bir davetiye göndermek ve başlamak için aşağıdaki butona tıklayın.",
        noInvite: "5 dakika içinde hiçbir şey almazsanız ve mobil numara doğruysa, lütfen bizimle iletişime geçin",
        updateDetails: "ve bilgilerinizi en kısa sürede güncelleyeceğiz.",
        supportTicketAlt: "Alternatif olarak bir destek bileti oluşturabilirsiniz",
        supportLink: "buradan",
        whatsappInstructions: "WhatsApp üzerinden davetiyeyi aldığınızda, nasıl katılacağınızı öğrenmek için talimatları dikkatlice okuyun.",
        noMobile: "Görünüşe göre telefon numaranız bizde yok, lütfen iletişime geçin",
        noMobile2: "sizi hemen başlatmak için",
        intro2: "Bir WhatsApp görevine katılmak üzeresiniz",
    },
    vi: {
        intro: "Để bắt đầu nhiệm vụ WhatsApp này, chúng tôi cần gửi cho bạn một lời mời.",
        checkNumber: "Trước khi làm điều đó, vui lòng kiểm tra xem đây có đúng là số điện thoại di động của bạn không:",
        mobileNumber: "Số điện thoại của bạn: +{msisdn}",
        incorrectDetails: "Nếu thông tin này không chính xác, vui lòng liên hệ",
        sendInvite: "Nếu không, hãy nhấn nút bên dưới để gửi lời mời đến điện thoại của bạn (qua WhatsApp) và bắt đầu.",
        noInvite: "Nếu bạn không nhận được gì trong vòng 5 phút và số di động là đúng, vui lòng liên hệ với chúng tôi qua",
        updateDetails: "và chúng tôi sẽ cập nhật thông tin của bạn càng sớm càng tốt.",
        supportTicketAlt: "Hoặc bạn có thể tạo một phiếu hỗ trợ",
        supportLink: "tại đây",
        whatsappInstructions: "Khi bạn nhận được lời mời trên WhatsApp, vui lòng đọc kỹ hướng dẫn về cách tham gia.",
        noMobile: "Có vẻ như chúng tôi chưa có số điện thoại của bạn, vui lòng liên hệ",
        noMobile2: "để bạn có thể bắt đầu ngay",
        intro2: "Bạn sắp tham gia vào một nhiệm vụ WhatsApp",
    },
    ar: {
        intro: "لبدء مهمة واتساب هذه، نحتاج إلى إرسال دعوة إليك.",
        checkNumber: "قبل ذلك، يرجى التحقق من أن هذا هو رقم هاتفك المحمول الصحيح:",
        mobileNumber: "رقم هاتفك المحمول: +{msisdn}",
        incorrectDetails: "إذا كانت هذه التفاصيل غير صحيحة، يرجى التواصل مع",
        sendInvite: "وإلا، انقر على الزر أدناه لإرسال دعوة إلى هاتفك (عبر واتساب) والبدء.",
        noInvite: "إذا لم تستلم أي شيء خلال 5 دقائق وكان رقم الهاتف صحيحًا، يرجى التواصل معنا على",
        updateDetails: "وسنقوم بتحديث بياناتك في أقرب وقت ممكن.",
        supportTicketAlt: "بدلاً من ذلك يمكنك إنشاء تذكرة دعم",
        supportLink: "هنا",
        whatsappInstructions: "بمجرد استلام الدعوة على واتساب، يرجى قراءة التعليمات بعناية حول كيفية المشاركة.",
        noMobile: "يبدو أننا لا نملك رقم هاتفك المحمول، يرجى التواصل مع",
        noMobile2: "لنبدأ معك في أقرب وقت",
        intro2: "أنت على وشك المشاركة في مهمة واتساب",
    }
};
